import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Welcome from './Welcome';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/app" element={<App />} />
        <Route path="*" element={<Welcome />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();